import { render, staticRenderFns } from "./conversation-list-item.vue?vue&type=template&id=66095daa&scoped=true"
import script from "./conversation-list-item.vue?vue&type=script&lang=js"
export * from "./conversation-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66095daa",
  null
  
)

export default component.exports